import ELementContentCustomerOrder from '@/components/sections/builder/elements/body/customer/customer_order/content';
import { CustomerOrderElementDataType } from './type';
import ElementSettingCustomerOrder from '@/components/sections/builder/elements/body/customer/customer_order/setting';
import { BetweenHorizontalStart } from 'lucide-react';

const defaultData: CustomerOrderElementDataType = {
  name: 'Orders',
  topPadding: 20,
  bottomPadding: 20,
};

export const ELementPreviewIcon = BetweenHorizontalStart;

const CustomerOrder = {
  type: 'customer_orders',
  group: 'body_customer_orders',
  defaultData,
  PreviewIcon: ELementPreviewIcon,
  Element: ELementContentCustomerOrder,
  Setting: ElementSettingCustomerOrder,
  isImmutable: true,
  maxEntries: 1,
};

export default CustomerOrder;
